// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"sD-z","smallCardRow":"tD-z","largeCardRow":"uD-z","productSearchRow":"vD-z","curatedRow":"wD-z"};